import axios from '../plugins/axios'
import type { AxiosResponse } from 'axios'
import type { IServerResponse } from '@/models/IServerResponse'
import { ISubscriptionPayload } from '@/models/ISubscriptionDevice'

const resource = 'api/v1/subscription'

export default {
    getSubscription(): Promise<AxiosResponse<IServerResponse<ISubscriptionPayload>>> {
        return axios.get(`${resource}/get_subscription`)
    },
    getUpdateBankDetails(): Promise<AxiosResponse<IServerResponse<{ checkout_url: string }>>> {
        return axios.get(`${resource}/update_bank_details`)
    },
    stopAutomaticRenewal(deviceUid: string): Promise<AxiosResponse<IServerResponse<void>>> {
        return axios.post(`${resource}/${deviceUid}/stop_renewal`)
    },
    renewSubscription(deviceUid: string): Promise<AxiosResponse<IServerResponse<{ checkout_url: string }>>> {
        return axios.post(`${resource}/${deviceUid}/renew_subscription`)
    },
    resumeSubscription(deviceUid: string): Promise<AxiosResponse<IServerResponse<{ checkout_url: string }>>> {
        return axios.post(`${resource}/${deviceUid}/resume_subscription`)
    },
    getCustomerPaymentHistory(): Promise<AxiosResponse<IServerResponse<{ portal_url: string }>>> {
        return axios.get(`${resource}/payment_history`)
    },
}